import React, { useEffect, useState } from 'react'
import BigNumber from 'bignumber.js'
import { CalculateIcon, IconButton, useModal } from '@pancakeswap-libs/uikit'
import { Address } from 'config/constants/types'
import { Farm } from 'state/types'
import ApyCalculatorModal from './ApyCalculatorModal'
import Roi from '../Roi'
import { FarmExtInterface } from '../Roi/FramInter'

export interface ApyButtonProps {
  // 0 组合农场，1单币农场，2牧场农场
  pledgeMode:number
  lpLabel?: string
  tokenPrice?: BigNumber
  apy?: BigNumber
  quoteTokenAdresses?: Address
  quoteTokenSymbol?: string
  tokenAddresses: Address
  harvestTokenSymbol?: string
  lpPrice?:BigNumber,
  bchPrice?:BigNumber,
  apr?:BigNumber,
  multiplier?:string,
  tokenBalance?:BigNumber,
  stakedBalance?:BigNumber,
  userDataState?:boolean
}

const ApyButton: React.FC<ApyButtonProps> = ({
  pledgeMode,
  lpLabel,
  quoteTokenAdresses,
  quoteTokenSymbol,
  tokenAddresses,
  tokenPrice,
  apy,
  harvestTokenSymbol,
  lpPrice,
  bchPrice,
  multiplier,
  tokenBalance,
  stakedBalance,
  userDataState
}) => {
  // const [userDataState,setUserDataState]=useState(false);
  // const [tokenBalance,setTokenBalance]=useState(new BigNumber(0));
  // const [stakedBalance,setStakedBalance]=useState(new BigNumber(0));
  // const [userDataState,setUserDataState]=useState(false);
  // useEffect(()=>{
  //   if(pledgeMode===2 && farmInfo.userInfo){
  //     setTokenBalance(farmInfo.userInfo.lpBalance)
  //     setStakedBalance(farmInfo.userInfo.stakedLp)
  //     setUserDataState(true)
  //   }
  //   if((pledgeMode===0 || pledgeMode===1)  && farmInfo.userData){
  //     setTokenBalance(farmInfo.userData.tokenBalance)
  //     setStakedBalance(farmInfo.userData.stakedBalance)
  //     setUserDataState(true)
  //   }
  // },[pledgeMode,farmInfo])

  const handleClickButton = (event): void => {
    event.stopPropagation()
    onPresentApyModal()
  }
  const [onPresentApyModal] = useModal(
    // pledgeMode===2?
    // <ApyCalculatorModal
    //     lpLabel={lpLabel}
    //     quoteTokenAdresses={quoteTokenAdresses}
    //     quoteTokenSymbol={quoteTokenSymbol}
    //     tokenAddresses={tokenAddresses}
    //     cakePrice={cakePrice}
    //     apy={apy}
    //     harvestTokenSymbol = {harvestTokenSymbol}
    // />:
    <Roi
        harvestTokenSymbol={harvestTokenSymbol}
        multiplier={multiplier}
        userDataState={userDataState}
        tokenBalance={tokenBalance}
        stakedBalance={stakedBalance}
        lpPrice={lpPrice}
        pledgeMode={pledgeMode}
        lpLabel={lpLabel}
        tokenPrice={tokenPrice}
        apy={apy}
    />
  )
  return (
    <IconButton onClick={handleClickButton} variant="text" size="sm" ml="4px">
      <CalculateIcon />
    </IconButton>
  )
}

export default ApyButton
